import React, { Component } from "react"

import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent"
import Validator from "../../../Components/FormComponent/Validator"

import ReactTooltip from "react-tooltip"

import Constants from "../../../Phi/Constants"

import moment from "moment"

import Source from "./../source"

import "./Support.css"

import iconEmail from "./assets/icon-email.svg"
import iconPhone from "./assets/icon-phone.svg"
import iconWhatsApp from "./assets/icon-whatsapp.svg"
import history from "../../../history"

class Support extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: Source.MAP_PAGES.DEFAULT,

            currentPhone: null,
            currentMessage: null,
        }
    }

    componentWillMount() {}

    componentWillReceiveProps(newProps) {}

    componentDidUpdate(oldProps, oldState) {
        if (oldProps.userProfile.phone !== this.props.userProfile.phone) {
            this.setState({ currentPhone: this.props.userProfile.phone })
        }
        if (oldProps.location.hash !== this.props.location.hash && !this.props.location.hash && this.props.location.pathname === "/support") {
            this.switchSupportPage()
        }
    }

    switchSupportPage(pageId) {
        switch (pageId) {
            case Source.MAP_PAGES.PHONE:
                this.props.changeLocation("support#phone")
                this.setState({ currentPage: Source.MAP_PAGES.PHONE, currentPhone: null, errorCurrentPhone: null })
                break
            case Source.MAP_PAGES.EMAIL:
                this.props.changeLocation("support#email")
                this.setState({ currentPage: Source.MAP_PAGES.EMAIL, currentMessage: null, errorCurrentMessage: null })
                break
            case Source.MAP_PAGES.WHATSAPP:
                window.open(Source.WHATSAPP_REDIRECTION, "_blank")
                break
            default:
                this.props.changeLocation("support")
                this.setState({ currentPage: Source.MAP_PAGES.DEFAULT })
        }
    }

    inputField = (index, key, label, placeholder, value, onChange, error) => (
        <div key={index}>
            <div className="hsg-support-modal-form-group">
                <label className="hsg-support-modal-form-label" htmlFor={key}>
                    {label}
                </label>
                <input
                    name={key}
                    className={`hsg-support-modal-form-input ${error ? "hsg-support-modal-form-input-error" : ""} ${
                        !onChange ? "hsg-support-modal-form-input-disabled" : ""
                    }`}
                    id={key}
                    data-tip=""
                    data-for={`${key}-tooltip`}
                    placeholder={placeholder}
                    type={"text"}
                    value={value || ""}
                    disabled={!onChange}
                    onChange={(e) => (onChange ? onChange(e.target.value, value, error) : null)}
                />
                <ReactTooltip className="hsg-auth-content-sign-up-form-error-tooltip" id={`${key}-tooltip`} type="error" effect="float">
                    {error}
                </ReactTooltip>
                {/* {error ? <span class="hsg-support-modal-form-error col-xs-12 padding-0">{this.state[error]}</span> : null} */}
            </div>
        </div>
    )

    textareaField = (index, key, label, placeholder, value, onChange, error) => (
        <div key={index}>
            <div className="hsg-support-modal-form-group">
                <label className="hsg-support-modal-form-label" htmlFor={key}>
                    {label}
                </label>
                <div>
                    <textarea
                        name={key}
                        className={`hsg-support-modal-form-input ${error ? "hsg-support-modal-form-input-error" : ""} ${
                            !onChange ? "hsg-support-modal-form-input-disabled" : ""
                        }`}
                        id={key}
                        data-tip=""
                        data-for={`${key}-tooltip`}
                        placeholder={placeholder}
                        value={value || ""}
                        disabled={!onChange}
                        onChange={(e) => (onChange ? onChange(e.target.value, value, error) : null)}
                    />
                </div>
                <ReactTooltip className="hsg-auth-content-sign-up-form-error-tooltip" id={`${key}-tooltip`} type="error" effect="float">
                    {error}
                </ReactTooltip>
            </div>
        </div>
    )

    supportMain = () => (
        <div className="col-xs-12 padding-right-0">
            <div className="hsg-support-card hsg-support-main-head-group">
                <div className="hsg-support-main-head">{Source.STRING_MAIN_HEAD}</div>
                <div className="hsg-support-main-sub-head">{Source.STRING_MAIN_SUB_HEAD}</div>
            </div>
        </div>
    )

    supportOptions = () => (
        <div className="col-xs-12 padding-0">
            {Source.MAP_SUPPORT_OPTIONS.map((element, index) => {
                const disabled = element.alternateContent && moment().days() < 6 && moment().subtract(8.5, "hours").format("hh") > 10 ? true : false

                return (
                    <div
                        key={index}
                        className="col-sm-4 col-xs-12 padding-right-0 hsg-support-main-options-default-height"
                        onClick={() => (disabled && element.alternateContent ? null : this.switchSupportPage(element.pageId))}
                    >
                        <div
                            style={{ cursor: disabled && element.alternateContent ? "default" : "pointer" }}
                            className="hsg-support-card hsg-support-main-options-group center hsg-support-main-options-default-height"
                        >
                            <div className="hsg-support-main-options-image">
                                <img src={element.icon} height={60} width={60} />
                            </div>
                            <div className="hsg-support-main-options-label">{element.label}</div>
                            {disabled && element.alternateContent ? (
                                <div className="hsg-support-main-options-content">{element.alternateContent}</div>
                            ) : (
                                <div className="hsg-support-main-options-content">{element.content}</div>
                            )}
                        </div>
                    </div>
                )
            })}
        </div>
    )

    renderDefault = () => (
        <div>
            <div className="col-xs-12 padding-left-0">{this.supportMain()}</div>
            <div className="col-xs-12 padding-left-0 margin-top-20">{this.supportOptions()}</div>
        </div>
    )

    supportPhone = () => (
        <div className="col-xs-12 padding-right-0">
            <div className="hsg-support-card hsg-support-phone-head-group">
                <div className="padding-top-16">
                    <img src={iconPhone} />
                </div>
                <div className="padding-top-8">
                    <div className="hsg-support-phone-head">{Source.STRING_PHONE_HEAD}</div>
                    <div className="hsg-support-phone-sub-head">{Source.STRING_PHONE_SUB_HEAD}</div>
                </div>
                <div className="margin-top-32">
                    {/* {this.inputField(0, 0, "Name", "", this.props.userProfile.fullName || "", null, "")} */}
                    {this.inputField(
                        1,
                        1,
                        "Phone Number",
                        "",
                        this.state.currentPhone || "",
                        (e) => this.setState({ currentPhone: e, errorCurrentPhone: Validator.required(e) || Validator.indianPhoneValidator(e) }),
                        this.state.errorCurrentPhone
                    )}
                </div>
                <div className="padding-top-8">
                    <button className="hsg-btn-white hsg-support-button-cancel" onClick={() => this.switchSupportPage()}>
                        {Source.STRING_BUTTON_CANCEL}
                    </button>
                    <button
                        className="hsg-btn hsg-support-button-submit"
                        onClick={() => {
                            if (!this.state.errorCurrentPhone && this.state.currentPhone) {
                                this.props.makeSupportCall(Constants.communicationMap.CALL.DEFAULT_PARAMS.To, this.state.currentPhone)

                                this.switchSupportPage()
                                Constants.showToaster("Give us a moment we are connecting you with our support team.", "INFO", 10000)
                            } else {
                                this.setState({
                                    errorCurrentPhone: Validator.required(this.state.currentPhone) || Validator.indianPhoneValidator(this.state.currentPhone),
                                })
                            }
                        }}
                    >
                        {Source.STRING_BUTTON_CONNECT}
                    </button>
                </div>
            </div>
        </div>
    )

    supportEmail = () => (
        <div className="col-xs-12 padding-right-0">
            <div className="hsg-support-card hsg-support-phone-head-group">
                <div className="padding-top-16">
                    <img src={iconEmail} />
                </div>
                <div className="padding-top-8">
                    <div className="hsg-support-phone-head">{Source.STRING_EMAIL_HEAD}</div>
                    <div className="hsg-support-phone-sub-head">{Source.STRING_EMAIL_SUB_HEAD}</div>
                </div>
                <div className="margin-top-32">
                    {/* {this.inputField(0, 0, "Name", "", this.props.userProfile.fullName || "", null, "")} */}
                    {this.textareaField(
                        1,
                        1,
                        "Message",
                        "",
                        this.state.currentMessage,
                        (e) => this.setState({ currentMessage: e, errorCurrentMessage: Validator.required((e && e.trim()) || "") }),
                        this.state.errorCurrentMessage
                    )}
                </div>
                <div className="padding-top-8">
                    <button className="hsg-btn-white hsg-support-button-cancel" onClick={() => this.switchSupportPage()}>
                        {Source.STRING_BUTTON_CANCEL}
                    </button>
                    <button
                        className="hsg-btn hsg-support-button-submit"
                        onClick={() => {
                            if (this.state.currentMessage && !this.state.errorCurrentMessage) {
                                this.props.sendSupportEmail(
                                    Constants.communicationMap.EMAILS.SUPPORT_MESSAGE.template,
                                    Constants.communicationMap.HELPERS.EMAIL_RECIPIENTS(Constants.communicationMap.EMAILS.SUPPORT_MESSAGE.recipients),
                                    Constants.communicationMap.HELPERS.EMAIL_VARIABLES({
                                        name: `${this.props.userProfile.fullName} -- ${this.props.userProfile.userId}`,
                                        email: this.props.userProfile.inEmail,
                                        content: this.state.currentMessage,
                                        platform: Constants.communicationMap.EMAILS.SUPPORT_MESSAGE.platform,
                                    }),
                                    `${this.props.userProfile.fullName} needs help! @${this.props.userProfile.inEmail}.`
                                )

                                this.switchSupportPage()
                                Constants.showToaster("Email Sent! We will get back to you as soon as possible.", "INFO", 10000)
                            } else {
                                this.setState({
                                    errorCurrentMessage: Validator.required((this.state.currentMessage && this.state.currentMessage.trim()) || ""),
                                })
                            }
                        }}
                    >
                        {Source.STRING_BUTTON_SUBMIT}
                    </button>
                </div>
            </div>
        </div>
    )

    render() {
        const { currentPage } = this.state

        let page

        switch (currentPage) {
            case Source.MAP_PAGES.PHONE:
                page = this.supportPhone()
                break
            case Source.MAP_PAGES.EMAIL:
                page = this.supportEmail()
                break
            case Source.MAP_PAGES.WHATSAPP:
                page = this.renderDefault()
                break
            default:
                page = this.renderDefault()
        }

        return <div className="container-fluid padding-left-0 margin-top-30 margin-bottom-20">{page}</div>
    }
}

export default Support
